import { redirect } from '@tanstack/react-router';
import type { Profile } from '@/apiTypes/profile';

/**
 * Route guard for use in a route's `beforeLoad` option.
 * Reads the profile from route context (populated by root beforeLoad)
 * and redirects to /login if unauthenticated.
 * Returns the authenticated user's profile for use in route context.
 */
export function requireAuthBeforeLoad({
  context,
  location,
}: {
  context: { profile: Profile | null };
  location: { href: string };
}) {
  if (!context.profile) {
    throw redirect({
      to: '/login',
      search: { redirect: location.href },
    });
  }
  return context.profile;
}
